import {
  submitGameCenterLeaderBoardScore,
  openGameCenterLeaderboard,
} from '@apps-in-toss/web-framework';
import { isInTossApp } from './env';

// 게임 점수 제출 — 보유 자산(냥)을 점수로 사용
// 토스 게임센터는 float string 요구. 자산을 "9999999.0" 형식으로.
export async function submitScore(cash: number): Promise<boolean> {
  if (!isInTossApp()) {
    console.log('[leaderboard mock] submitScore', cash);
    return true;
  }
  try {
    const result = await submitGameCenterLeaderBoardScore({
      score: String(Math.max(cash, 0)),
    });
    return result?.statusCode === 'SUCCESS';
  } catch {
    return false;
  }
}

// 게임센터 리더보드 화면 열기
export async function openLeaderboard(): Promise<void> {
  if (!isInTossApp()) {
    console.log('[leaderboard mock] open');
    return;
  }
  try { await openGameCenterLeaderboard(); } catch { /* noop */ }
}
